var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFaqSvg = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_i_12117_27537)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.83594 1.16699V5.83366L7.58594 4.08366L9.33594 5.83366V1.16699",
  stroke: "#F35B22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_i_12117_27537)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.33594 11.3753V2.62533C2.33594 2.23855 2.48958 1.86762 2.76307 1.59413C3.03656 1.32064 3.4075 1.16699 3.79427 1.16699H11.0859C11.2406 1.16699 11.389 1.22845 11.4984 1.33785C11.6078 1.44724 11.6693 1.59562 11.6693 1.75033V12.2503C11.6693 12.405 11.6078 12.5534 11.4984 12.6628C11.389 12.7722 11.2406 12.8337 11.0859 12.8337H3.79427C3.4075 12.8337 3.03656 12.68 2.76307 12.4065C2.48958 12.133 2.33594 11.7621 2.33594 11.3753ZM2.33594 11.3753C2.33594 10.9886 2.48958 10.6176 2.76307 10.3441C3.03656 10.0706 3.4075 9.91699 3.79427 9.91699H11.6693",
  stroke: "#F35B22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_i_12117_27537",
  x: 5.33594,
  y: 0.666992,
  width: 5.5,
  height: 6.66699,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_12117_27537"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_i_12117_27537",
  x: 1.83594,
  y: 0.666992,
  width: 11.3359,
  height: 13.667,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_12117_27537"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFaqSvg);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";